import { styled } from 'styled-components';
import Spinner from 'components/Spinner';

const LoadingWrapper = styled.section`
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fb;
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ebf1fc;
  padding: 40px 20px 28px 18px;
  border-radius: 22px;
  width: 400px;
`;

const LoadingMessage = styled.h1`
  font-size: 1.6em;
  font-weight: 500;
  color: #2c4078;
  opacity: 0.94;
  margin-top: 16px;
`;

/**
 * A loader component that displays a spinner while dashboard is loading
 *
 * @returns {JSX.Element} - the loader component
 */
export default function Loading() {
  return (
    <LoadingWrapper>
      <SpinnerContainer>
        <Spinner />
        <LoadingMessage>Your dashboard is loading...</LoadingMessage>
      </SpinnerContainer>
    </LoadingWrapper>
  );
}
